import React, { useState } from "react";
import {
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    Typography
} from "@mui/material";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";

function ConfirmationDialog(props) {
    const [open, setOpen] = useState(false);

    const showDialog = () => {
        setOpen(true);
    };

    const hideDialog = () => {
        setOpen(false);
        props.onClose?.();
    };

    const confirmRequest = () => {
        const result = props.response?.();
        if (result !== false) {
            hideDialog();
        }
    };

    return (
        <>
            {props.children(showDialog)}
            {open && (
                <Dialog
                    open={open}
                    onClose={hideDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth="xs"
                    fullWidth
                >
                    <Box
                        sx={{
                            backgroundColor: (theme) => theme.palette.primary.main,
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            px: 2,
                            py: 1,
                        }}
                    >
                        <Typography
                            variant='h6'
                            sx={{ color: (theme) => theme.palette.primary.contrastText }}
                        >
                            {props.header ?? "Delete Confirmation" }
                        </Typography>
                        <IconButton
                            aria-label='close'
                            onClick={hideDialog}
                            sx={{
                                color: (theme) => theme.palette.primary.contrastText,
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {props.description}
                        </DialogContentText>
                        {props.content}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={confirmRequest} color="primary" variant="contained">
                            {props.confirmButtonText ?? "Yes" }
                        </Button>
                        <Button onClick={hideDialog} color="primary" variant={"outlined"}>
                            {props.cancelButtonText ?? "No" }
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    );
}

export default ConfirmationDialog;